<template>
  <div class="app-footer">
    <div class="app-footer__container">
      <div class="app-footer__wrapper">
        <div class="app-footer-left">
          <div class="app-footer__logo">
            <a :href="!isLoggedIn ? countryBaseUrl : '/home'">
              <img
                :src="require('@/app/assets/logo_white.svg')"
                width="131"
                height="28"
                alt="Logo"
                crossorigin="anonymous"
              />
            </a>
            <div v-html="translate('Land a better<br>job faster')" />
          </div>
          <AppFooterSocialLinks />
        </div>
        <AppFooterMenu />
      </div>
      <p class="app-footer__copyright">
        &copy; JobLeads 2007 - {{ currentYear }} | {{ translate('All rights reserved') }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AppFooterSocialLinks from './AppFooterSocialLinks.vue';
import AppFooterMenu from './AppFooterMenu.vue';

export default {
  name: 'AppFooter',
  components: { AppFooterSocialLinks, AppFooterMenu },

  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
  computed: {
    ...mapGetters({
      navigationUrlList: 'navigationUrlList',
      countryBaseUrl: 'country/countryBaseUrl',
      isLoggedIn: 'user/isLoggedIn',
    }),
  },
};
</script>

<style lang="scss">
@import './AppFooter.scss';
</style>
